import React, { useState } from "react";

export function Modal( {showmodal, closeModalPopup} ) {
    const [modalState, setModalState] = useState(showmodal);

    // close the modal and set modal state to false in saved.js
    const closeModal = () => {
        setModalState(false);
        closeModalPopup();
    }

    return (
        <>
            <div className={`modal-popup ${!showmodal?`modal-popup__close`:``}`}>
                <div className="modal-popup__wrap wdg-padding--lg wdg-bg--white wdg-text--black">
                    <span dangerouslySetInnerHTML={{ __html: window.drupalSettings.naco_mynaco.anonymous_bookmark }}></span>
                    <button onClick={closeModal} aria-label="close modal">
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8 7.47588L14.6087 0.867188L16 2.25849L9.3913 8.86719L16 15.4759L14.6087 16.8672L8 10.2585L1.3913 16.8672L0 15.4759L6.6087 8.86719L0 2.25849L1.3913 0.867188L8 7.47588Z" fill="black"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </>
    );
}
